import { useEffect } from 'react';

const onBeforeUnload = (event: BeforeUnloadEvent) => {
  event.preventDefault();

  // eslint-disable-next-line @typescript-eslint/no-deprecated, sonarjs/deprecation -- `false` is fallback for older browsers to show a default confirmation alert
  event.returnValue = false;
};

const lockNaviagation = () => {
  window.addEventListener('beforeunload', onBeforeUnload);
};

const unlockNavigation = () => {
  window.removeEventListener('beforeunload', onBeforeUnload);
};

/**
 * Hook that prevents navigation with a native browser dialog
 */
export const useNavigationStop = (shouldPreventNavigation: boolean) => {
  useEffect(() => {
    if (shouldPreventNavigation) {
      lockNaviagation();
    }

    return () => {
      unlockNavigation();
    };
  }, [shouldPreventNavigation]);

  return { lockNaviagation, unlockNavigation };
};
